import { Api } from "./api";

const IrregularVehicleService = {
  confirmIrregularVehicle: (irregularId, body) => 
    Api.put(`/agents/confirm-irregular-vehicle/${irregularId}`, 
      body, 
      { headers: { 'Authorization': sessionStorage.getItem('token')} }
    ),

  fineIrregularVehicle: (irregularId) => 
    Api.put(`/agents/fine-irregular-vehicle/${irregularId}`, {},
      { headers: { 'Authorization': sessionStorage.getItem('token')} }
    ),

  findIrregularVehicles: (area='a') => 
    Api.get(`/agents/find-irregular-vehicles/${area}`,
      { headers: { 'Authorization': sessionStorage.getItem('token')} }
    ),

  findIrregularVehicle: (licensePlate) => 
    Api.get(`/agents/find-irregular-vehicle/${licensePlate}`,
      { headers: { 'Authorization': sessionStorage.getItem('token')} }
    ),

  confirmedIrregularityHistory: (cpfAgent='', startDate='', endDate='', fined='') => 
    Api.get(`/agents/confirmed-irregularity-history?cpfAgent=${cpfAgent}&startDate=${startDate}&endDate=${endDate}&fined=${fined}`,
      { headers: { 'Authorization': sessionStorage.getItem('token')} }
    ),
}

export default IrregularVehicleService